<template>
  <div v-bind:class="{'small':className === 'small'}">
    <vue-ladda
      @click="makePhoneCall()"
      button-class="btn btn-success btn-xs phoneCall_btn"
      data-style="zoom-in"
      :loading="phoneCallLoading"
    ><i class="icon-fa icon-fa-phone-square"></i>
    </vue-ladda>
  </div>
</template>

<script>
import api from "@/api";
import VueLadda from "vue-ladda/src/vue-ladda.vue";

export default {
  components: {
    VueLadda
  },
  props: ["phone", "order", "recordId", "onCall", 'className'],
  computed: {
    $userPhoneNumbers() {
      return this.$store.getters["user/phoneNumbers"].numbers;
    }
  },
  data() {
    return {
      loading: false,
      phoneCallLoading: false,
      modalData: {}
    };
  },
  methods: {
    async makePhoneCall() {
      this.phoneCallLoading = true;
      let {data} = await api.post("/telephony/makePhoneCallAction", {
        action: "callBackByRecord",
        recordId: this.recordId
      });
      if (data.success) {
        toastr["success"](data.message || data.sip || '', "Вызов создан");
        if (this.onCall) {
          this.onCall();
        }
      } else {
        toastr["warning"](
          data.message || "Вызов не создан, обратитесь к адмнистратору"
        );
      }
      this.phoneCallLoading = false;
    },
    selectPhone() {
      if (!this.phone || !this.phone.valid) {
        toastr["warning"]("Номер телефона не валидирован");
        return;
      }
      let phones = [];

      if (!this.$userPhoneNumbers || !this.$userPhoneNumbers.length) {
        toastr["warning"](
          "Номера телефонов не подгружены, обратитесь к администратору"
        );
        return;
      }
      let projectPhones = this.$userPhoneNumbers.filter(
        p => p.project_id === this.order.site_id
      );

      if (!projectPhones || !projectPhones.length) {
        toastr["warning"](
          "Номера телефонов не подгружены, обратитесь к администратору"
        );
        return;
      }

      let primaryNum = projectPhones.find(
        p =>
          p.city_id === +this.order.city_id &&
          +this.order.site_id === p.project_id
      );
      if (!primaryNum) {
        primaryNum = projectPhones.find(
          p => p.city_id === 0 && +this.order.site_id === p.project_id
        );
      }
      if (primaryNum) {
        phones.push({...primaryNum, recommended: true});
      }
      phones = [
        ...phones,
        ...projectPhones.reduce((acc, p) => {
          if (!primaryNum || p.id !== primaryNum.id) {
            acc.push(p);
          }
          return acc;
        }, [])
      ];
      this.modalData = {
        phoneNum: this.phone.phone,
        phones
      };
      if (!phones.length) {
        toastr["warning"](
          "У Вас нет номеров для этой заявки, обратитесь к администратору"
        );
        return;
      }
      this.$refs.phoneCallSelect.open();
    }
  }
};
</script>

<style scoped>
.small i {
  font-size: 15px !important;
}

.small button {
  padding: 2px !important;
}

button {
  height: 100%;
}

.phoneCall_btn i {
  font-size: 20px;
  text-align: center;
}

.fs-20 {
  font-size: 20px;
}
</style>
